import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import SideBar from './components/SideBar';
import ToolFrame from './pages/ToolFrame';
import Facturation from './pages/Facturation';
import BillingBoard from './pages/BillingBoard';
import GlobalSearch from './components/GlobalSearch';
import config from './config';
import './styles/global.css';
import './styles/crm-motion.css';

function App() {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem(config.userKey);
    return saved ? JSON.parse(saved) : null;
  });

  // Injection des couleurs client via CSS variables
  useEffect(() => {
    document.documentElement.style.setProperty('--primary', config.primaryColor);
    document.documentElement.style.setProperty('--accent',  config.accentColor);
    document.title = config.clientName + ' — CRM';
  }, []);

  if (!user) {
    return (
      <Router>
        <Routes>
          <Route path="*" element={<Login setUser={setUser} />} />
        </Routes>
      </Router>
    );
  }

  const isMasterRole = ['admin', 'master', 'maitre'].includes(String(user.role || '').toLowerCase());
  const authorizedApps = config.apps.filter(app => !app.permission || isMasterRole || Boolean(user.permissions?.[app.permission]));
  const authorizedDefaultRoute = authorizedApps.length && authorizedApps.some(app => `/${app.key}` === config.defaultRoute)
    ? config.defaultRoute
    : authorizedApps.length ? `/${authorizedApps[0].key}` : null;

  return (
    <Router>
      <div className="admin-page">
        <SideBar user={user} setUser={setUser}>
          <GlobalSearch apps={authorizedApps} />
        </SideBar>

        <div className="iframe-wrapper">
          <Routes>
            {authorizedApps.map(app => (
              <Route
                key={app.key}
                path={`/${app.key}`}
                element={app.key === 'facturation' ? <BillingBoard /> : app.key === 'suivi-facturation' ? <Facturation /> : <ToolFrame app={app} />}
              />
            ))}
            <Route path="*" element={authorizedDefaultRoute ? <Navigate to={authorizedDefaultRoute} /> : <div style={{padding: 30}}>Aucune application ne vous a été attribuée.</div>} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
